module.exports = __webpack_public_path__ + "static/img/beachball.6751c71.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/beachball.png
// module id = ao6K
// module chunks = 0